export default {
  /**
   * text: '',
   * close: true,
   * timeout: 4000,
   * status: '',
   */
  queueBigSnackbar: [],
  disclaimer: {
    loading: false,
    lastUpdate: null,
    data: {},
    dataImg: {},
  },
  officeParameters: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  profissionaisPermissao: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  internalUsers: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  previousPage: {},
  fullDataClient: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  // {{NEXT}}
}
